module.exports = __webpack_public_path__ + "img/message.1a6f8956.png";